export default __webpack_public_path__ + "static/media/mixkit-fast-double-click-on-mouse-275.d820ee7b.mp3";